

import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";


export const handleGetAvailableFollowupSlots = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {};

          if (data?.memberId) {
            params.memberId = data.memberId;
        }
        
        if (data?.specialistId) {
            params.specialistId = data.specialistId;
        }

        return asyncThunkWrapper(
            {
                method: "GET",
                headers: headers(),
                url: `${BASEURI}/user/appointment-create/available-slots`,
                params,
            },
            thunkAPI,
            { toast: false }
        );
    }
);

